<div
  class="flex flex-col"
  nrcDoubleClick
  (singleClickEvent)="handleItemClickEvent(index)"
>
  <form
    class="relative w-full h-[9rem] flex items-center shadow-[0_6px_14px_#00000033] bg-[#fefefe0d] hover:bg-[#fefefe1a] rounded-10 border-2 border-solid transition-all duration-200"
    [ngClass]="{
      'border-white/5': !isSelected(),
      'border-cyan-highlight': isSelected()
    }">
    @if (isFolderCard) {
      <div class="absolute top-2 right-2 z-30 rounded-full shadow-[0_3px_6px_#00000029] bg-white/10 flex items-center justify-center hover:scale-95 transition-transform duration-250">
        <nrc-button
          class="w-8 h-8 realive"
          [icon]="'folder'"
          [buttonType]="buttonType.ICON"
          [role]="actionRole.TRANSPARENT_SECONDARY"
          [tooltipText]="'Open Card'"
          (clickEvent)="handleOpenCardEvent(index)"
        />
      </div>
    }

    <div class="relative w-full h-full">
      @if (thumbnailFile() || !isFolderCard) {
        <nrc-media-preview
          class="flex justify-center w-full h-full overflow-hidden rounded-lg"
          [mimetype]="thumbnailFile() ? thumbnailFile()?.mimetype ?? '' : fileItem() ? fileItem()?.mimetype ?? '' : ''"
          [source]="thumbnailFileSource() || fileItemSource()"
          [thumbnailSource]="thumbnailFileSource() || fileItemSource()"
          [mediaPreviewTypes]="['image', 'video-snippet']"
        />

        @if (isExportingToPdf() || hasExportedPdf()) {
          <div class="absolute inset-0 flex flex-col items-center justify-center rounded-lg bg-black/10 backdrop-blur-md">
            <div class="flex flex-col items-center gap-2">
              <nrc-icon
                [name]="'file-type-pdf'"
                [fillColor]="isExportingToPdf() ? 'warning' : 'white'"
                [ngClass]="{ 'animate-blink-scale w-12 h-12': isExportingToPdf(), 'w-16 h-16': hasExportedPdf() }"
              />
              @if (isExportingToPdf()) {
                <span class="px-2 text-sm font-medium text-center text-white drop-shadow-md">
                  Exporting to PDF in progress...
                </span>
              } @else if (hasExportedPdf()) {
                <span class="px-2 text-sm font-medium text-center text-white drop-shadow-md">
                  A PDF version of this document will be displayed.
                </span>
              }
            </div>
          </div>
        }
        @if (isPdfExportSupported()) {
          <div class="absolute flex flex-col space-y-1 top-1 right-1">
            <nrc-button
              class="relative w-8 h-8"
              [icon]="'file-type-pdf'"
              [buttonType]="buttonType.ICON"
              [role]="actionRole.SECONDARY"
              [tooltipText]="'Export to PDF'"
              (clickEvent)="handleFileExportPdfEvent()"
            />
          </div>
        }
      } @else {
        <div class="w-full h-full rounded-lg bg-white/10">
        </div>
      }

      @if (showCheckbox) {
        <nrc-checkbox class="absolute top-2 left-2" [checkStatus]="isSelected() ? 'checked' : 'unchecked'" />
      }
    </div>
  </form>

  <div class="flex flex-col items-start w-full px-1 pt-2">
    <div class="flex flex-col justify-center w-full">
      <span class="overflow-hidden text-sm text-ellipsis whitespace-nowrap" [ngClass]="{
          'text-neutral-300 font-normal': !isSelected(),
          'text-cyan-highlight font-medium': isSelected()
        }">
        {{ selectedItem ? selectedItem.label : '' }}
      </span>
    </div>
  </div>
</div>
